import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { IMetaGlobalConnectionStatus } from './types';

export const META_GLOBAL_CONNECTION_VERIFY_QUERY_KEY = 'admin/ads/meta/global-connection/verify';

export function useMetaGlobalConnectionVerifyQuery({ enabled = true }: { enabled?: boolean } = {}) {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () =>
			userSession.webServiceHelper.callAsync<IMetaGlobalConnectionStatus>(
				'admin/ads/meta/global-connection/verify',
				'GET'
			),
		queryKey: [META_GLOBAL_CONNECTION_VERIFY_QUERY_KEY],
		enabled,
		// The call actually hits Meta — never auto-refetch in the background.
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
		staleTime: Infinity,
		meta: {
			toastErrorMessage: "Couldn't verify the Meta System User connection.",
			errorLogging: { fn: 'useMetaGlobalConnectionVerifyQuery' },
		},
	});
}
